import {
  Flex,
  Text,
  List,
  Box,
  Image,
  MantineTheme,
  useMantineTheme,
} from "@mantine/core";
import { memo } from "react";
import { BiDumbbell } from "react-icons/bi";

import { BsDot } from "react-icons/bs";
import {
  getTimeInAMPMFormat,
  isTodayTomorrowsDate,
} from "src/utils/dateHelper";
import { IMeetingPage } from ".";

type IListItemProps = {
  handleNav: (e: string) => void;
  meeting: IMeetingPage[0];
};

export const IconGym = (theme: MantineTheme, imgUrl?: string) => {
  return (
    <Flex
      sx={{
        borderRadius: 4,
        width: 40,
        height: 40,
      }}
      align={"center"}
      justify={"center"}
      style={{ backgroundColor: theme.colors.primaryTextColor[6] }}
    >
      {imgUrl ? (
        <img
          style={{
            width: 25,
            height: 25,
          }}
          src={imgUrl}
          alt="Service"
        />
      ) : (
        <BiDumbbell size={22} color={theme.colors.primary[6]} />
      )}
    </Flex>
  );
};

function ListItem({ handleNav, meeting }: IListItemProps) {
  const { name, id, attendees, maxOccupancy, startAt, imgUrl } = meeting;
  const isAvailable = attendees && attendees.length < (maxOccupancy || 0);
  const theme = useMantineTheme();

  return (
    <List.Item my={15} py={10}>
      <Flex gap={"sm"} sx={{ cursor: "pointer" }} onClick={() => handleNav(id)}>
        {IconGym(theme, imgUrl || "")}

        <Box>
          <Text size={18}>{name}</Text>
          <Flex gap={6} align={"center"} pt={3}>
            <Text
              size={12}
              sx={{ padding: "4px 8px", borderRadius: 30 }}
              bg={isAvailable ? "#F6F6F6" : "#FFCACA"}
              fw={500}
              style={{
                backgroundColor: theme.colors.primary[6],
                color: theme.colors.primaryTextColor[6],
              }}
            >
              {isAvailable ? "Available" : "Class Full"}
            </Text>
            <BsDot />

            <Text size={12}>
              {isTodayTomorrowsDate(startAt)} {getTimeInAMPMFormat(startAt)}
            </Text>
          </Flex>
        </Box>
      </Flex>
    </List.Item>
  );
}

export default memo(ListItem);
